import React from "react";
import { TextField, Button, CircularProgress } from "@mui/material";
import {
  LearningSection,
  ModelInputArea,
  InputWrapper,
} from "../styles/styled.components";

const ModelInput = ({
  modelInput,
  onModelInputChange,
  handleModelDetailInputChange,
  enteredModelDetail,
}) => {
  const BUTTON_HEIGHT = 36.5;
  const SPINNER_SIZE_RATIO = 0.6;
  return (
    <LearningSection>
      <div className="num_title">기본 설정</div>
      <ModelInputArea>
        <InputWrapper $width="40%">
          <TextField
            placeholder="규칙명"
            value={modelInput}
            onChange={onModelInputChange}
            fullWidth
            sx={{
              background: "#fff",
              "& .MuiInputBase-root": {
                // fontFamily: "Pretendard",
                height: `${BUTTON_HEIGHT}px`,
              },
              "& .MuiOutlinedInput-input": {
                padding: "8px 14px",
              },
            }}
          />
        </InputWrapper>
        {/* <Button
          variant="contained"
          onClick={onLearn}
          sx={{
            fontFamily: "Pretendard",
            minWidth: "64px",
            height: `${BUTTON_HEIGHT}px`,
            padding: "6px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: isLearning ? "wait" : "pointer",
          }}
          disabled={isDisabled}
        >
          {isLearning ? (
            <CircularProgress
              size={BUTTON_HEIGHT * SPINNER_SIZE_RATIO}
              sx={{
                color: "white",
              }}
            />
          ) : (
            "학습하기"
          )}
        </Button> */}
        <InputWrapper $width="60%">
          <TextField
            placeholder="규칙에 대한 설명을 입력하세요"
            value={enteredModelDetail}
            onChange={handleModelDetailInputChange}
            fullWidth
            sx={{
              background: "#fff",
              "& .MuiInputBase-root": {
                fontFamily: "Pretendard",
                height: `${BUTTON_HEIGHT}px`,
              },
              "& .MuiOutlinedInput-input": {
                padding: "8px 14px",
              },
            }}
          />
        </InputWrapper>
        {/* <Button
          variant="contained"
          onClick={onLearn}
          sx={{
            fontFamily: "Pretendard",
            minWidth: "64px",
            height: `${BUTTON_HEIGHT}px`,
            padding: "6px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: isLearning ? "wait" : "pointer",
          }}
          disabled={isDisabled}
        >
          {isLearning ? (
            <CircularProgress
              size={BUTTON_HEIGHT * SPINNER_SIZE_RATIO}
              sx={{
                color: "white",
              }}
            />
          ) : (
            "학습하기"
          )}
        </Button> */}
      </ModelInputArea>
    </LearningSection>
  );
};

export default React.memo(ModelInput);
